/* eslint-disable react/prop-types */
import React from 'react'
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu';
import {Link} from 'react-router-dom';

export default function Navbar(props) {
    return (
        <AppBar position="fixed">
            <Toolbar>
                {props.mobile ? (
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={props.openSideBar}
                    >
                        <MenuIcon />
                    </IconButton>
                ):null}
                <Typography variant="h6">
                    <Link to='/' style={{textDecoration: 'none', color: 'inherit'}}>
                    Hemovigilância
                    </Link>
                </Typography>
            </Toolbar>
        </AppBar>
    )
}
